// src/components/StyledPaper.js
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

const StyledPaper = styled(Paper)(({ theme }) => ({
  width: 'auto',
  minWidth: 300,
  maxWidth: 500,
}));

export default StyledPaper;
